import ArtifactGroupType from "../base/ArtifactGroupType";


const LoongSymbol = {
  id: '115',
  name: 'Loong Symbol',
  groupIcon: 'WhispersOfJade',
  type: ArtifactGroupType.WHISPERS_OF_JADE,
  icon: 'LoongSymbol',
  power: 50
};

export default LoongSymbol;
